import { Map } from 'immutable';

import { getAIOperation } from '../../ai';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { AI_OPERATION } from '@/constants/ai';
import { OPERATIONS } from '@/constants/bulkEdit';
import { ATTRIBUTE } from '@/constants/attributes';

import actions from '@/actions';

export function category({ channel, preview }) {
  switch (channel) {
    case EBAY: {
      if (preview.has(ATTRIBUTE.ITEM_CATEGORY)) {
        const payload = [Map({ type: OPERATIONS[EBAY].ITEM_CATEGORY, value: preview.get(ATTRIBUTE.ITEM_CATEGORY) })];

        const keywordsOperation = getAIOperation({
          channel,
          value: { destination: ATTRIBUTE.KEYWORDS, operation: AI_OPERATION.GENERATE },
        });

        payload.push(keywordsOperation);

        return {
          actions: [actions.bulkEdit.updateMenuForCategory(preview.get(ATTRIBUTE.ITEM_CATEGORY))],
          payload,
        };
      }

      if (preview.has(ATTRIBUTE.STORE_CATEGORY)) {
        return {
          payload: Map({ type: OPERATIONS[EBAY].STORE_CATEGORY, value: preview.get(ATTRIBUTE.STORE_CATEGORY) }),
        };
      }

      return {};
    }

    case ETSY: {
      return {
        actions: [actions.bulkEdit.updateMenuForCategory(preview.get(ATTRIBUTE.CATEGORY))],
        payload: Map({ type: OPERATIONS[ETSY].CATEGORY, value: preview.get(ATTRIBUTE.CATEGORY) }),
      };
    }

    case SHOPIFY: {
      return {
        payload: Map({ type: OPERATIONS[SHOPIFY].CATEGORY, value: preview.get(ATTRIBUTE.CATEGORY) }),
      };
    }

    case FAIRE: {
      return {
        payload: Map({ type: OPERATIONS[FAIRE].CATEGORY, value: preview.get(ATTRIBUTE.CATEGORY) }),
      };
    }

    default: {
      return {};
    }
  }
}
